import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { SecuenciaPage } from './pages/SecuenciaPage';
import { DiagnosticoPage } from './pages/diagnostico/DiagnosticoPage';
import { TecnologiaPage } from './pages/tecnologia/TecnologiaPage';
render(<BrowserRouter data-id="element-142">
    <Routes data-id="element-143">
      <Route path="/" element={<App data-id="element-145" />} data-id="element-144" />
      <Route path="/secuencia" element={<SecuenciaPage data-id="element-147" />} data-id="element-146" />
      <Route path="/diagnostico" element={<DiagnosticoPage data-id="element-149" />} data-id="element-148" />
      <Route path="/tecnologia" element={<TecnologiaPage data-id="element-151" />} data-id="element-150" />
    </Routes>
  </BrowserRouter>, document.getElementById('root'));